import React, { useState } from 'react';
import { connect } from 'react-redux';
import TopHeader from '../../template/TopHeader';
import MarketingTopNav from '../MarketingTopNav';
import JourneysSection from './JourneysSection';
import JourneysHelp from './JourneysHelp';
import { useMarketingControl, SalonRunsMarketingBanner } from '../SalonRunsMarketing';
import { keepFrom } from '../goUp';
import '../campaigns/Campaigns.css';

/**
 * Marketing › Journeys
 * Multi-step sequences that follow each client (welcome series, rebook
 * nudges, win-backs). The page shell matches Campaigns/Performance; the
 * top-nav Add button opens the recipe gallery.
 */

function MarketingJourneys(props) {
  const [addSignal, setAddSignal] = useState(0);
  const [helpOpen, setHelpOpen] = useState(false);
  // Salon-controlled marketing: the salon runs this stylist's marketing, so
  // their own journeys are read-only and none of them runs.
  const control = useMarketingControl();

  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="journeys">
            {control.managed ? null : (
              <button
                type="button"
                className="catalogue-add-btn"
                onClick={() => setAddSignal((n) => n + 1)}
              >
                Add
              </button>
            )}
          </MarketingTopNav>
          <div className="catalogue-content-container">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="cmp-wrap">
                    <div className="cmp-head">
                      <div className="cmp-head-text">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <h1 className="cmp-title">Journeys</h1>
                          <button type="button" className="pv2-help-btn" onClick={() => setHelpOpen(true)} aria-label="How journeys work" title="How journeys work">?</button>
                        </div>
                        <p className="cmp-subtitle">
                          Multi-step sequences that follow each client, like a welcome email with a rebooking nudge two weeks later. Journeys end early the moment the client books.
                        </p>
                      </div>
                    </div>
                    {control.managed && <SalonRunsMarketingBanner salonName={control.salonName} />}
                    <JourneysSection
                      variant="page"
                      managedBySalon={control.managed}
                      addSignal={addSignal}
                      openJourneyId={props.location?.state?.openJourneyId}
                      openRecipe={props.location?.state?.openRecipe}
                      onOpenConsumed={() => props.history.replace('/marketing-journeys', keepFrom(props.location))}
                    />
                    {helpOpen && <JourneysHelp onClose={() => setHelpOpen(false)} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(MarketingJourneys);
